import {useEffect,useState} from 'react';
import {Linking,Platform} from 'react-native';
import {accountActionLink} from '../shared/account-action-link.js';
export function useAccountActionLink(){
 const [action,setAction]=useState(()=>Platform.OS==='web'&&typeof window!=='undefined'?accountActionLink(window.location.hash):null);
 useEffect(()=>{
  if(Platform.OS==='web'){const read=()=>setAction(accountActionLink(window.location.hash));window.addEventListener('hashchange',read);return()=>window.removeEventListener('hashchange',read);}
  let active=true;void Linking.getInitialURL().then(url=>{if(active)setAction(accountActionLink(url));}).catch(()=>{});
  const listener=Linking.addEventListener('url',({url})=>setAction(accountActionLink(url)));return()=>{active=false;listener.remove();};
 },[]);
 const handled=()=>{setAction(null);if(Platform.OS==='web'&&typeof window!=='undefined'&&accountActionLink(window.location.hash))window.history.replaceState(null,'',window.location.pathname+window.location.search);};
 return {action,handled};
}
